/**
 * @generated SignedSource<<6553655742bb47652db75f0df478f99a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type unified_ingest_header_set_rows_params = {
  file_id: string;
  header_rows: ReadonlyArray<number>;
  owner_name: string;
};
export type useUnifiedIngestHeaderSetMutation$variables = {
  params: unified_ingest_header_set_rows_params;
};
export type useUnifiedIngestHeaderSetMutation$data = {
  readonly unified_ingest_header_set_rows: {
    readonly file_id: string;
    readonly owner_name: string;
  };
};
export type useUnifiedIngestHeaderSetMutation = {
  response: useUnifiedIngestHeaderSetMutation$data;
  variables: useUnifiedIngestHeaderSetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "params",
        "variableName": "params"
      }
    ],
    "concreteType": "unified_ingest_header_set_rows_output",
    "kind": "LinkedField",
    "name": "unified_ingest_header_set_rows",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "file_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "owner_name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUnifiedIngestHeaderSetMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUnifiedIngestHeaderSetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2fae6ecc9f7b25a2cb4b35ff331a9c98",
    "id": null,
    "metadata": {},
    "name": "useUnifiedIngestHeaderSetMutation",
    "operationKind": "mutation",
    "text": "mutation useUnifiedIngestHeaderSetMutation(\n  $params: unified_ingest_header_set_rows_params!\n) {\n  unified_ingest_header_set_rows(params: $params) {\n    file_id\n    owner_name\n  }\n}\n"
  }
};
})();

(node as any).hash = "166f483040c0d54f05767e0e10801891";

export default node;
